import React from "react";

import { Grid } from "@mui/material";

import SuarteSlider from "./SuartaSlider";

function SuarteWorldDesktop() {
  return (
    <div className='bgworld'>
      <div className="">
        <Grid container spacing={2}>
          <Grid item md={5} lg={5} xs={12} sm={12}>
            <SuarteSlider />
          </Grid>
        </Grid>
      </div>

      
    </div>
  );
}

export default SuarteWorldDesktop;
